import {toAbsoluteUrl} from "../../_helpers";
import objectPath from "object-path";

const Config = {
    default: {
        'logo': null,
        'module_name': 'OptimumDesk',
        'className': '',
        'bg': '#1E1E2D'
    },

    easeedesk: {
        'logo': toAbsoluteUrl('/media/logos/modules/easeedesk.png'),
        'module_name': 'Easeedesk',
        'className': 'easeedesk',
        'bg': '#32777E'
    },

    inventoree: {
        'logo': toAbsoluteUrl('/media/logos/modules/inventoree.png'),
        'module_name': 'Inventoree',
        'className': 'inventoree',
        'bg': '#B16131'
    },

    overview: {
        'logo': toAbsoluteUrl('/media/logos/modules/overview.png'),
        'module_name': 'Overview',
        'className': 'overview',
        'bg': '#797979'
    },

    opteemum: {
        'logo': toAbsoluteUrl('/media/logos/modules/opteemum.png'),
        'module_name': 'Opteemum',
        'className': 'opteemum',
        'bg': '#1FA67A'
    },

    proactivitee: {
        'logo': toAbsoluteUrl('/media/logos/modules/proactivitee.png'),
        'module_name': 'Proactivitee',
        'className': 'proactivitee',
        'bg': '#D83430'
    },

    softsee: {
        'logo': toAbsoluteUrl('/media/logos/modules/softsee.png'),
        'module_name': 'Softsee',
        'className': 'softsee',
        'bg': '#52BBB6'
    },

    easeetask: {
        'logo': toAbsoluteUrl('/media/logos/modules/easeetask.png'),
        'module_name': 'Easeetask',
        'className': 'easeetask',
        'bg': '#E6AC23'
    },

    saveenergee: {
        'logo': toAbsoluteUrl('/media/logos/modules/saveenergee.png'),
        'module_name': 'Saveenergee',
        'className': 'saveenergee',
        'bg': '#55B42B'
    },

    printeeng: {
        'logo': toAbsoluteUrl('/media/logos/modules/printeeng.png'),
        'module_name': 'Printeeng',
        'className': 'printeeng',
        'bg': '#A8A433'
    },

    securitee: {
        'logo': toAbsoluteUrl('/media/logos/modules/securitee.png'),
        'module_name': 'Securitee',
        'className': 'securitee',
        'bg': '#4E7CB5'
    },

    protectee: {
        'logo': toAbsoluteUrl('/media/logos/modules/protectee.png'),
        'module_name': 'Protectee',
        'className': 'protectee',
        'bg': '#534F8B'
    },

    productivitee: {
        'logo': toAbsoluteUrl('/media/logos/modules/productivitee.png'),
        'module_name': 'Productivitee',
        'className': 'productivitee',
        'bg': '#D98C31'
    }
};

export function moduleConfig(module) {
    const moduleConfig = objectPath.get(Config, module);

    if (moduleConfig) {
        return moduleConfig;
    }

    return Config.default;
}
